/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductAttribute from './product-attribute';
import ProductAttributeDetail from './product-attribute-detail';
import ProductAttributeUpdate from './product-attribute-update';
import ProductAttributeDeleteDialog from './product-attribute-delete-dialog';

const ProductAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductAttribute />} />
    <Route path="new" element={<ProductAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<ProductAttributeDetail />} />
      <Route path="edit" element={<ProductAttributeUpdate />} />
      <Route path="delete" element={<ProductAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductAttributeRoutes;
